import { ArrowUpRight } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useLanguage } from "@/contexts/LanguageContext";

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_pandemic-ready/artifacts/718pfmf4_New%20Company%20Logo.svg";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_pandemic-ready/artifacts/pe0mvtqk_RoLink_logo_2025%20%28Vector%20SVG%20for%20Web%29.svg";

const FOOTER_GROUPS = [
  { key: "platform", items: ["Technology", "Applications", "Biosafety", "Science"] },
  { key: "company",  items: ["Team", "Partners", "News", "Contact"] },
  { key: "legal",    items: ["Privacy Policy", "Terms of Service", "Cookie Policy"] },
];

export default function Footer() {
  const { theme } = useTheme();
  const { t } = useLanguage();
  const isLight = theme === "light";
  return (
    <footer className="bg-[#050505] border-t border-[#1F2937]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img data-testid="footer-logo" src={isLight ? LOGO_LIGHT : LOGO_DARK} alt="RoLink Biotechnology" className="h-9" />
            <p className="text-sm text-[#9CA3AF] mt-4 leading-relaxed">
              {t("footer.orgLine")}
            </p>
            <p className="text-xs text-[#4B5563] mt-3 leading-relaxed">
              {t("footer.founded")}
            </p>
            <p className="text-xs text-[#4B5563] mt-1 leading-relaxed">
              {t("footer.addr")}
            </p>
          </div>
          {FOOTER_GROUPS.map(group => (
            <div key={group.key}>
              <h4 className="text-xs uppercase tracking-[0.2em] text-[#9CA3AF] font-medium font-mono mb-4">{t(`footer.groups.${group.key}`)}</h4>
              <ul className="space-y-3">
                {group.items.map(item => (
                  <li key={item}>
                    <a href="#" className="text-sm text-[#4B5563] hover:text-[#F3F4F6] transition-colors">{t(`footer.links.${item}`)}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-[#1F2937] flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <p className="text-xs text-[#4B5563]">&copy; {new Date().getFullYear()} {t("footer.orgLine")} {t("footer.copy")}</p>
            <p className="text-[10px] text-[#374151] mt-1">{t("footer.reg")}</p>
            <p className="text-[10px] text-[#374151] mt-1">
              {t("footer.photoCredits")}: Csortos Szabolcs / PTE
            </p>
          </div>
          <a
            href="mailto:info@rolinkbiotechnology.com"
            className="flex items-center gap-1 text-xs text-[#9CA3AF] hover:text-[#EE1D25] transition-colors"
          >
            info@rolinkbiotechnology.com <ArrowUpRight size={12} />
          </a>
        </div>
      </div>
    </footer>
  );
}
